/**
 * MakerStack fonts — the picker in the STYLE tab. Each font maps to a CSS
 * font-family stack and, for non-system fonts, a Google Fonts family to load.
 */

export interface Font {
  id: string
  name: string
  /** CSS font-family value. */
  stack: string
  /** Google Fonts family + weights spec (omit for system fonts). */
  google?: string
}

export const FONTS: Font[] = [
  {
    id: "inter",
    name: "Inter",
    stack: "'Inter', system-ui, -apple-system, sans-serif",
    google: "Inter:wght@400;500;600;700;800",
  },
  {
    id: "system",
    name: "System",
    stack: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  },
  {
    id: "geist",
    name: "Geist",
    stack: "'Geist', system-ui, sans-serif",
    google: "Geist:wght@400;500;600;700",
  },
  {
    id: "sora",
    name: "Sora",
    stack: "'Sora', system-ui, sans-serif",
    google: "Sora:wght@400;500;600;700;800",
  },
  {
    id: "spaceGrotesk",
    name: "Space Grotesk",
    stack: "'Space Grotesk', system-ui, sans-serif",
    google: "Space+Grotesk:wght@400;500;600;700",
  },
  {
    id: "playfair",
    name: "Playfair",
    stack: "'Playfair Display', Georgia, serif",
    google: "Playfair+Display:wght@400;500;600;700;800",
  },
  {
    id: "lora",
    name: "Lora",
    stack: "'Lora', Georgia, serif",
    google: "Lora:wght@400;500;600;700",
  },
  {
    id: "dmMono",
    name: "DM Mono",
    stack: "'DM Mono', ui-monospace, 'SF Mono', monospace",
    google: "DM+Mono:wght@400;500",
  },
  {
    id: "fraunces",
    name: "Fraunces",
    stack: "'Fraunces', Georgia, serif",
    google: "Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700",
  },
]

export const DEFAULT_FONT_ID = "inter"

const FONT_BY_ID: Record<string, Font> = Object.fromEntries(FONTS.map((f) => [f.id, f]))

export function getFont(id: string | undefined): Font {
  return (id && FONT_BY_ID[id]) || FONT_BY_ID[DEFAULT_FONT_ID]
}

/** Build the Google Fonts <link> href for a font, or null for system fonts. */
export function googleFontHref(font: Font): string | null {
  if (!font.google) return null
  return `https://fonts.googleapis.com/css2?family=${font.google}&display=swap`
}
